import React, { useState } from "react";
import "./Css/ByDefault.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_BASE from "../config/api";

const ExamList = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { softwareId, standardId } = useParams();
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const targetPaperId = searchParams.get("targetId");
  console.log(targetPaperId, 'target')


  const filteredData = examData.filter(
    (exam) =>
      exam.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      exam.id.toString().includes(searchQuery)
  );

  /* ✅ PAGINATION */
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/Papers/default-papers?softwareId=${softwareId}&standardId=${standardId}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
            }
          }
        );

        const mapped = res.data.map(p => {
          const start = new Date(`1970-01-01T${p.paperStartTime}`);
          const end = new Date(`1970-01-01T${p.paperEndTime}`);
          const durationMin = (end - start) / 60000;

          return {
            id: p.paperId,
            name: p.paperName,
            type: p.paperType,
            class: p.standardName,
            subject: p.subjectName ?? "-",
            date: new Date(p.paperDate).toLocaleDateString("mr-IN"),
            duration: `${durationMin} मिनिटे`,
            marks: p.marks,
            status: p.paperStatus
          };
        });

        setExamData(mapped);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPapers();
  }, [softwareId, standardId]);

  return (
    <div className="exam-containerr">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt; परीक्षा तयार करा &gt;&gt; <span>By Default</span>
        </h3>
      </div>
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>

        <select>
          <option> परीक्षेचे नाव</option>
          <option>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा </option>
          <option>ज. नवोदय विद्यालय प्रवेश परीक्षा</option>
          <option>NMMS Exam</option>
        </select>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>परीक्षेचे नाव</th>
              <th>परीक्षा प्रकार</th>
              <th>इयत्ता</th>
              <th>विषय</th>
              <th>परीक्षेची तारीख</th>
              <th>कालावधी</th>
              <th>एकूण गुण</th>
              <th>स्थिती</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((exam, index) => (
                <tr key={exam.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{exam.name}</td>
                  <td>{exam.type}</td>
                  <td>{exam.class}</td>
                  <td>{exam.subject}</td>
                  <td>{exam.date}</td>
                  <td>{exam.duration}</td>
                  <td>{exam.marks}</td>
                  <td>
                    <span
                      className={`status ${exam.status === "आगामी परीक्षा"
                        ? "upcoming"
                        : "completed"
                        }`}
                    >
                      {exam.status}
                    </span>
                  </td>
                  <td>
                    <svg xmlns="http://www.w3.org/2000/svg"
                      onClick={() =>
                        navigate(`/dashboard/exampreveiw/${exam.id}?targetId=${targetPaperId}`)
                      }
                      className="action-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0056 15.1538C13.0218 15.1538 13.884 14.7981 14.5924 14.0868C15.3007 13.3754 15.6549 12.5117 15.6549 11.4955C15.6549 10.4793 15.2992 9.61708 14.5879 8.90875C13.8765 8.20042 13.0128 7.84625 11.9966 7.84625C10.9805 7.84625 10.1182 8.20192 9.40988 8.91325C8.70154 9.62458 8.34738 10.4883 8.34738 11.5045C8.34738 12.5207 8.70304 13.3829 9.41438 14.0913C10.1257 14.7996 10.9895 15.1538 12.0056 15.1538ZM12.0011 14.2C11.2511 14.2 10.6136 13.9375 10.0886 13.4125C9.56362 12.8875 9.30112 12.25 9.30112 11.5C9.30112 10.75 9.56362 10.1125 10.0886 9.5875C10.6136 9.0625 11.2511 8.8 12.0011 8.8C12.7511 8.8 13.3886 9.0625 13.9136 9.5875C14.4386 10.1125 14.7011 10.75 14.7011 11.5C14.7011 12.25 14.4386 12.8875 13.9136 13.4125C13.3886 13.9375 12.7511 14.2 12.0011 14.2ZM12.0039 18C9.83787 18 7.86387 17.4106 6.08187 16.2317C4.29988 15.0529 2.96529 13.4757 2.07812 11.5C2.96529 9.52433 4.29896 7.94708 6.07912 6.76825C7.85929 5.58942 9.83238 5 11.9984 5C14.1644 5 16.1384 5.58942 17.9204 6.76825C19.7024 7.94708 21.037 9.52433 21.9241 11.5C21.037 13.4757 19.7033 15.0529 17.9231 16.2317C16.143 17.4106 14.1699 18 12.0039 18Z" fill="#313030" />
                    </svg>

                  </td>
                </tr>

              ))
            ) : (
              <tr>
                <td colSpan="10" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamList;
